import { PropsWithChildren } from "react";
const Content = ({ children }: PropsWithChildren) => (
    <div className="h-screen w-full overflow-auto bg-background">
        {children}
    </div>
)
export default Content;